//Angular Library Components
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, JsonpModule, Http } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { ModalModule } from 'ng2-modal';
import { CommonModule } from "@angular/common";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
//Custom Components
import { ConfiguratorComponent } from './components/configurator/configurator.component';
import { HeaderComponent } from './components/common-header/common-header.component';
import { FooterComponent } from './components/common-footer/common-footer.component';
import { BannerAreaComponent } from './components/banner-area/banner-area.component';
import { SpecialModeComponent } from './components/special-mode/special-mode.component';
import { SpecialModeCancelComponent } from './components/special-mode/special-mode-cancel.component';
import { StandardOptions } from './components/standard-options/standard-options.component';
import { TechnicalData } from './components/technical-data/technical-data.component';
import { CloseDescriptionOnClick } from './components/banner-area/close-description-on-click';
import { ColorPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-color/expert-color-placeholder-null';
import { AddColorPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-additional-color/expert-additional-color-placeholder-null';
import { FactoryPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-factory-options/expert-factory-placeholder-null';
import { LocalPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-local-options/expert-local-placeholder-null';
import { TrimPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-trim/expert-trim-placeholder-null';
import { PackagePlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-package-options/expert-package-placeholder-null';
import { RimPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-rim/expert-rim-placeholder-null';
import { UpholsteryPlaceholderNull } from './components/selectable-tabs/expert-screen-components/expert-upholstery/expert-upholstery-placeholder-null';


//Normal Mode Components
import { SelectedOptionsComponent } from './components/selectable-tabs/normal-screen-components/selected-options/selected-options.component';
import { ColorOptions } from './components/selectable-tabs/normal-screen-components/color/color.component';
import { ErrorOverlay} from './components/selectable-tabs/error-overlay/error-overlay.component';
import { AdditionalColorOptions } from './components/selectable-tabs/normal-screen-components/additional-color/additional-color.component';
import { FactoryOptions } from './components/selectable-tabs/normal-screen-components/factory-options/factory-options.component';
import { LocalOptions } from './components/selectable-tabs/normal-screen-components/local-options/local-options.component';
import { PackageOptions } from './components/selectable-tabs/normal-screen-components/package-options/package-options.component';
import { PackageDetailsComponent } from './components/selectable-tabs/normal-screen-components/package-details/package-details.component';
import { TrimOptions } from './components/selectable-tabs/normal-screen-components/trim/trim.component';
import { RimOptions } from './components/selectable-tabs/normal-screen-components/rim/rim.component';
import { UpholsteryOptions } from './components/selectable-tabs/normal-screen-components/upholstery/upholstery.component';
import { OptionSelectionPanel } from './components/selectable-tabs/normal-screen-components/option-selection-panel/option-selection-panel'
import { NormalModeOptionSelection } from './components/selectable-tabs/normal-screen-components/normal-mode-option-selection/normal-mode-option-selection';
import { ResetConfirmationComponent } from './components/selectable-tabs/normal-screen-components/reset-confirmation/reset-confirmation.component';
import { SuccessMessageComponent } from './components/selectable-tabs/normal-screen-components/success-message/success-message.component';
import { SummaryValidationComponent } from './components/selectable-tabs/normal-screen-components/summary-validations/summary-validations.component'
import { CancelComponent } from './components/selectable-tabs/normal-screen-components/cancel-confirmation/cancel-confirmation.component';
//Common components
import { AlternateScreenComponent } from './components/selectable-tabs/alternate-options/alternate-options.component';
import { InitialAlternateScreenComponent } from './components/selectable-tabs/initial-alternate-options/initial-alternate-options.component';

//Expert Mode Components
import { ExpertModeOptionSelection } from './components/selectable-tabs/expert-screen-components/expert-mode-options/expert-mode-option-selection';
import { ExpertColorOptions } from './components/selectable-tabs/expert-screen-components/expert-color/expert-color.component';
import { ExpertAdditionalColorOptions } from './components/selectable-tabs/expert-screen-components/expert-additional-color/expert-additional-color.component';
import { ExpertFactoryOptions } from './components/selectable-tabs/expert-screen-components/expert-factory-options/expert-factory-options.component';
import { ExpertLocalOptions } from './components/selectable-tabs/expert-screen-components/expert-local-options/expert-local-options.component';
import { ExpertPackageOptions } from './components/selectable-tabs/expert-screen-components/expert-package-options/expert-package-options.component';
import { ExpertUpholsteryOptions} from './components/selectable-tabs/expert-screen-components/expert-upholstery/expert-upholstery.component';
import { ExpertRimOptions } from './components/selectable-tabs/expert-screen-components/expert-rim/expert-rim.component';
import { ExpertTrimOptions } from './components/selectable-tabs/expert-screen-components/expert-trim/expert-trim.component';
import { ExpertReset } from './components/selectable-tabs/expert-screen-components/expert-reset/expert-reset.component';
import { ExpertSelectedOptionsComponent } from './components/selectable-tabs/expert-screen-components/expert-selected-options/expert-selected-options.component';
import { ExpertValidation } from './components/selectable-tabs/expert-screen-components/expert-validation/expert-validation.component';
import { ExpertSuccessMessageComponent } from './components/selectable-tabs/expert-screen-components/expert-success-message/expert-success-message.component';
import { ExpertSummaryValidationComponent } from './components/selectable-tabs/expert-screen-components/expert-summary-validation/expert-summary-validation.component';
import { ExpertViewAll } from './components/selectable-tabs/expert-screen-components/expert-view-all/expert-view-all.component';
import { ExpertCancelComponent } from './components/selectable-tabs/expert-screen-components/expert-cancel-confirmation/expert-cancel-confirmation.component';
//Services
import { DataLoaderService } from './services/data-loader.service';
import { CommonDataService } from './services/common-data.service';
import { VehicleInfoService } from './services/vehicle-info.service';
import { PriceCalculationService } from './services/price-calculation.service';
import { ProgressBarService } from './services/progress-bar.service';
import { ResetService } from './services/reset.service'
import { AlternateOptionsService } from './services/alternate-options.service';
import { ImageLoaderService } from './services/img-urls/img-urls.service';
import { SummaryValidationService } from './services/summary-validation.service';
import { SummaryService } from './services/summary.service';
import { SortingService } from './services/sorting.service'
import { TokenEncrption } from './services/encryption-File.service';


//Internalization
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets//i18n/', '.json');
}

@NgModule({
  imports: [

    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    CommonModule ,
    ModalModule,
    Ng2AutoCompleteModule,
    JsonpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    //Normal components
    ConfiguratorComponent,
    HeaderComponent,
    FooterComponent,
    ErrorOverlay,
    SpecialModeComponent,
    SpecialModeCancelComponent,
    BannerAreaComponent,
    OptionSelectionPanel,
    NormalModeOptionSelection,
    ColorOptions,
    AdditionalColorOptions,
    TrimOptions,
    RimOptions,
    UpholsteryOptions,
    FactoryOptions,
    LocalOptions,
    PackageOptions,
    CancelComponent,
    PackageDetailsComponent,
    SuccessMessageComponent,
    StandardOptions,
    TechnicalData,
    SelectedOptionsComponent,
    CloseDescriptionOnClick,
    ResetConfirmationComponent,
    SummaryValidationComponent,
    //Expert Components
    ExpertModeOptionSelection,
    ExpertColorOptions,
    ExpertAdditionalColorOptions,
    ExpertFactoryOptions,
    ExpertLocalOptions,
    ExpertPackageOptions,
    ExpertTrimOptions,
    ExpertReset,
    ExpertSelectedOptionsComponent,
    ExpertValidation,
    ExpertCancelComponent,
    ExpertSuccessMessageComponent,
    ExpertSummaryValidationComponent,
    ExpertRimOptions,
    ExpertUpholsteryOptions,
    ExpertViewAll,
    //Common Components
    AlternateScreenComponent,
    InitialAlternateScreenComponent,
    //Placeholder Null Components
    ColorPlaceholderNull,
    AddColorPlaceholderNull,
    FactoryPlaceholderNull,
    LocalPlaceholderNull,
    TrimPlaceholderNull,
    PackagePlaceholderNull,
    RimPlaceholderNull,
    UpholsteryPlaceholderNull
  ],
  entryComponents: [
    ColorOptions,
    AdditionalColorOptions,
    TrimOptions,
    RimOptions,
    UpholsteryOptions,
    FactoryOptions,
    LocalOptions,
    PackageOptions
  ],
  providers: [
    ColorOptions,
    AlternateScreenComponent,
    ExpertSummaryValidationComponent,
    ExpertModeOptionSelection,
    ExpertValidation,
    SummaryValidationComponent,
    DataLoaderService,
    VehicleInfoService,
    CommonDataService,
    PriceCalculationService,
    ProgressBarService,
    ResetService,
    AlternateOptionsService,
    ImageLoaderService,
    SummaryValidationService,
    SummaryService,
    SortingService,
    TokenEncrption
  ],
  bootstrap: [ConfiguratorComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts